import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { CodeProgressOverrides, PulseCodeProgressOverrides } from './styled-components'

const useRegistrationCode = () => {
  const isPulse = usePulseScope()

  return { isPulse, progressOverrides: isPulse ? PulseCodeProgressOverrides : CodeProgressOverrides }
}

export default useRegistrationCode
